import { render, staticRenderFns } from "./PriceWrapper.vue?vue&type=template&id=460cb3d8&scoped=true"
import script from "./PriceWrapper.vue?vue&type=script&lang=js"
export * from "./PriceWrapper.vue?vue&type=script&lang=js"
import style0 from "./PriceWrapper.vue?vue&type=style&index=0&id=460cb3d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460cb3d8",
  null
  
)

export default component.exports